import {
  AI_TOOL_SELECT_USAGE_NOTE,
  AI_TOOL_WHERE_USAGE_NOTE,
  searchFallbackUsedSchema,
} from '@erikdakoda/ai-tool/findManyAiToolInput';
import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { promptsToolGroupIcon } from './toolGroupIcon';
import { findPromptsInputSchema } from './findPromptsInputSchema';

export { findPromptsInputSchema };

export const findPromptsOutputSchema = z.object({
  results: z
    .array(z.unknown())
    .describe(
      'Rows from findMany. Default minimal mask: id, name, description, group, handle. Shape follows caller flat `select` when provided.',
    ),
  count: z.number().int().describe('Number of rows returned (after take).'),
  searchFallbackUsed: searchFallbackUsedSchema,
});

export type FindPromptsInput = z.infer<typeof findPromptsInputSchema>;
export type FindPromptsOutput = z.infer<typeof findPromptsOutputSchema>;

export const findPrompts: AiTool<undefined, FindPromptsInput, FindPromptsOutput> = {
  id: 'findPrompts',

  group: 'prompts',

  ...promptsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description: `List prompts using the structured filter DSL. ${AI_TOOL_WHERE_USAGE_NOTE}

Returns the same minimal default mask as \`searchPrompts\` (id, name, description, group, handle). ${AI_TOOL_SELECT_USAGE_NOTE}

Use \`searchText\` for indexed text search on name (substring) and description/text (full-text / english stem). Does not search group or handle. \`searchFallbackUsed\` is true only when typo-tolerant fallback ran. Prompt version numbers are not filterable here — use \`readPrompt\` with \`versions: true\`.`,
    inputSchema: zodSchema(findPromptsInputSchema),
    outputSchema: zodSchema(findPromptsOutputSchema),
  }),
};
